"use strict";

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.unscopables.flat-map");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _lodash = _interopRequireDefault(require("lodash"));

var _prefixNegativeModifiers = _interopRequireDefault(require("../util/prefixNegativeModifiers"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default() {
  return function (_ref) {
    var addUtilities = _ref.addUtilities,
        e = _ref.e,
        theme = _ref.theme,
        variants = _ref.variants;
    var generators = [function (size, modifier) {
      var _ref2;

      return _ref2 = {}, _defineProperty(_ref2, ".".concat(e((0, _prefixNegativeModifiers.default)('space-y', modifier)), " > :not(template) ~ :not(template)"), {
        '--space-y-reverse': '0',
        'margin-top': "calc(".concat(size, " * calc(1 - var(--space-y-reverse)))"),
        'margin-bottom': "calc(".concat(size, " * var(--space-y-reverse))")
      }), _defineProperty(_ref2, ".".concat(e((0, _prefixNegativeModifiers.default)('space-x', modifier)), " > :not(template) ~ :not(template)"), {
        '--space-x-reverse': '0',
        'margin-right': "calc(".concat(size, " * var(--space-x-reverse))"),
        'margin-left': "calc(".concat(size, " * calc(1 - var(--space-x-reverse)))")
      }), _ref2;
    }];

    var utilities = _lodash.default.flatMap(generators, function (generator) {
      return [].concat(_toConsumableArray(_lodash.default.flatMap(theme('space'), generator)), [{
        '.space-y-reverse > :not(template) ~ :not(template)': {
          '--space-y-reverse': '1'
        },
        '.space-x-reverse > :not(template) ~ :not(template)': {
          '--space-x-reverse': '1'
        }
      }]);
    });

    addUtilities(utilities, variants('space'));
  };
}